import { isRemoteWrite } from "./modules/settings/screenBaseline.js";
//#region src/engine/geometryRegisters.ts
var POSITION_REGISTER = "ui.position";
var SIZE_REGISTER = "ui.size";
var VIEWPORT_REGISTER = "settings.viewport";
var ViewportRegister = {
	origin: "origin",
	zoomLevel: "zoomLevel"
};
var isOwnStep = (context, tags) => !context.remote && !isRemoteWrite(tags);
//#endregion
export { POSITION_REGISTER, SIZE_REGISTER, VIEWPORT_REGISTER, ViewportRegister, isOwnStep };
